import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for tracking encounter toggle graduation state
 * Tracks consecutive V2 note generations for auto-graduation logic
 */
interface EncounterToggleSliceState {
  consecutiveV2Notes: number;
}

const initialState: EncounterToggleSliceState = {
  consecutiveV2Notes: 0,
};

export const encounterToggleSlice = createSlice({
  name: 'encounters/toggle',
  initialState,
  reducers: {
    incrementV2NoteCount: state => {
      state.consecutiveV2Notes += 1;
    },
    resetV2NoteCount: state => {
      state.consecutiveV2Notes = 0;
    },
  },
});

export const { incrementV2NoteCount, resetV2NoteCount } = encounterToggleSlice.actions;
export default encounterToggleSlice.reducer;
